<div role="dialog" aria-labelledby="helpTitle" class="view-help" #viewHelp>
  <h2 class="view-help__header" id="helpTitle">Help</h2>
  <!-- Close -->
  <button class="view-help__close" (click)="handleCloseClick()" type="button">
    <app-icon icon="times" aria-hidden="true"></app-icon>
    <span class="visually-hidden">Close help modal</span>
  </button>
  <div class="view-help__inner">
    <app-tabs tabSize="medium" tabAlign="center" [activeTab]="activeTab" cdkFocusInitial>
      <app-tab label="Navigation Basics" id="helpBasics" aria-controls="basicsPanel">
        <div role="tabpanel" aria-labelledby="helpBasics" tabindex="0" id="basicsPanel">
          <ul class="view-help__group">
            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-rotate.svg"
                  alt="A heart with an arrow wrapped around it, which symbolises objects being rotated withing the 3D viewport." />
              </div>
              <div class="view-help__label">Rotate</div>
              Click and drag or use one finger to change the viewing angle.
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-pan.svg"
                  alt="A heart with left and right arrows pointing away from it, which symbolises objects being panned within the 3D viewport" />
              </div>
              <div class="view-help__label">Pan</div>
              Hold the shift key and drag or use two fingers to move the model's position.
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-zoom.svg"
                  alt="A heart with a magnifying glass over it, which symbolises zooming into and out from an object within the 3D viewport." />
              </div>
              <div class="view-help__label">Zoom</div>
              Scroll up and down or pinch with two fingers to zoom in or out.
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-learn.svg"
                  alt="A heart with a smaller region colored in blue and a popup window specifying that the Right Ventricle is selected." />
              </div>
              <div class="view-help__label">Explore the Anatomy</div>
              Click or tap an anatomic structure or label to learn more.
            </li>
          </ul>
        </div>
      </app-tab>

      <app-tab label="All Controls" id="helpAll" aria-controls="allPanel">
        <div role="tabpanel" aria-labelledby="helpAll" tabindex="0" id="allPanel">
          <h3 class="view-help__section-header">Mouse</h3>

          <ul class="view-help__group">
            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-mouse-hold-left.svg"
                  alt="A mouse with the left button being held in." />
              </div>
              Hold left button to rotate
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-mouse-hold-right.svg"
                  alt="A mouse with the right button being held in." />
              </div>
              Hold right button to pan
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-mouse-single-click-left.svg"
                  alt="A mouse with the left button being clicked." />
              </div>
              Single-click left button to select a structure
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-mouse-double-click-left.svg"
                  alt="A mouse with the left button being double clicked." />
              </div>
              Double-click left button to auto-focus on a structure
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-mouse-long-press-left.svg"
                  alt="A mouse with the left button being held in for a long duration." />
              </div>
              Long-click to fly to a structure
            </li>
          </ul>

          <h3 class="view-help__section-header">Keyboard</h3>

          <ul class="view-help__group">
            <li class="view-help__item">
              <div class="view-help__image">
                <img src="assets/images/widget/help-keyboard-rotate.svg" alt="The arrow keys." />
              </div>
              Rotate with arrows
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-keyboard-pan.svg"
                  alt="The W, A, S and D keys." />
              </div>
              Pan up (W), left (A), down (S), right(D)
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-keyboard-zoom.svg"
                  alt="The plus and minus keys grouped together or the E and C keys grouped together." />
              </div>
              Zoom out (-, C) and zoom in (+, E)
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-keyboard-slow-motion.svg"
                  alt="The shift key." />
              </div>
              Hold with any previous key to slow down motion
            </li>
          </ul>

          <h3 class="view-help__section-header">Trackpad</h3>

          <ul class="view-help__group">
            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-trackpad-single-tap.svg"
                  alt="A finger clicking the trackpad once." />
              </div>
              Single-tap to auto-focus a structure
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-trackpad-double-tap.svg"
                  alt="A finger clicking the trackpad twice." />
              </div>
              Double-tap to select a structure
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-trackpad-long-press.svg"
                  alt="A finger pressing for a long duration on the trackpad." />
              </div>
              Long-press to fly to a structure
            </li>

            <li class="view-help__item">
              <div class="view-help__image">
                <img
                  src="assets/images/widget/help-trackpad-scroll.svg"
                  alt="Two fingers pressing the trackpad while moving vertically." />
              </div>
              Scroll up and down to zoom
            </li>
          </ul>

          <h3 class="view-help__section-header">In-App</h3>

          <ul class="view-help__group">
            <li class="view-help__item">
              <app-icon class="view-help__icon" icon="plus" aria-hidden="true"></app-icon>
              <span class="visually-hidden">
                The plus symbol, which represents zooming in in the camera control menu.
              </span>
              Zoom in
            </li>

            <li class="view-help__item">
              <app-icon class="view-help__icon" icon="minus" aria-hidden="true"></app-icon>
              <span class="visually-hidden">
                The minus symbol, which represents zooming out in the camera control menu.
              </span>
              Zoom out
            </li>

            <li class="view-help__item">
              <app-icon class="view-help__icon" icon="location" aria-hidden="true"></app-icon>
              <span class="visually-hidden">
                The map pin symbol, which resets the camera in the camera control menu.
              </span>
              Recenter 3D model
            </li>

            <li class="view-help__item">
              <app-icon class="view-help__icon" icon="arrows" aria-hidden="true"></app-icon>
              <span class="visually-hidden">
                Arrows pointing in four directions, which represents panning in the camera control
                menu.
              </span>
              Pan
            </li>
          </ul>
        </div>
      </app-tab>

      <app-tab label="Keyboard Shortcuts" id="helpShortcuts" aria-controls="shortcutsPanel">
        <div role="tabpanel" aria-labelledby="helpShortcuts" tabindex="0" id="shortcutsPanel">
          <app-view-shortcuts></app-view-shortcuts>
        </div>
      </app-tab>
    </app-tabs>
  </div>
</div>
